import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import clsx from 'clsx'
import { useReactiveVar } from '@apollo/client'

import { SelectProfilePhotoDialog } from '../components'
import { ReactComponent as CameraIcon } from '../assets/icons/camera-icon.svg'

import { deleteAuthData } from '../hooks/useAuth'
import { apolloAuthData } from '../services/apollo'

const Profile = () => {
  const auth = useReactiveVar(apolloAuthData)
  let navigate = useNavigate()
  const [open, setOpen] = useState(false)

  const handleLogout = () => {
    deleteAuthData(() => navigate('/login', { replace: true }))
  }

  const profilePicURL = auth.user?.profilePicURL ?? null

  return (
    <>
      <SelectProfilePhotoDialog
        title="Customize Profile Picture"
        open={open}
        setOpen={setOpen}
        onClose={() => setOpen(false)}
      />
      <main className="min-h-[calc(100vh-200px)]">
        <div className="container pb-20 pt-14">
          <h1 className="mb-10 text-center text-4xl font-bold text-skin-accent">
            your profile.
          </h1>
          <div className="mx-auto flex min-h-[437px] w-[315px] flex-col items-center rounded-[19px] bg-white p-6 shadow-lg">
            {/** Upload photo widget */}
            <div className="relative mb-6 h-[105px] w-[105px] overflow-hidden rounded-full ring-1 ring-light-gray">
              <img
                src={profilePicURL}
                alt="profile"
                className={clsx(
                  'absolute left-0 top-0 h-full w-full rounded-full',
                  !profilePicURL || profilePicURL.length === 0 ? 'hidden' : ''
                )}
              />
              <span
                className={clsx(
                  'absolute left-[50%] top-[20px] block w-4/5 -translate-x-[50%] text-center text-[12px] leading-[1.2] text-dark-gray',
                  auth.user?.profilePicURL && 'hidden'
                )}
              >
                Upload a photo
              </span>
              <button
                type="button"
                className={clsx(
                  'absolute bottom-0 left-1/2 flex h-[40px] w-[120px] -translate-x-1/2 items-center justify-center bg-dark-gray text-dark-gray transition-colors hover:bg-black-olive',
                  auth.user?.profilePicURL && 'opacity-50'
                )}
                onClick={() => setOpen(true)}
              >
                <CameraIcon className="h-[15px] w-[21px] [&_path]:!fill-white" />
              </button>
            </div>

            {/** User's name */}
            <span className="text-xl font-bold text-flame">
              {`${auth.user?.firstName ?? ''} ${
                auth.user?.lastName ?? ''
              }`.trim()}
            </span>

            {/** User's location */}
            <span className="text-sm text-dark-charcoal">
              {auth.user?.location || '--'}
            </span>

            {/** User's email */}
            <span className="my-6 text-sm text-argent">
              {auth.user?.email || '--'}
            </span>

            {/** Points */}
            <span className="text-xl font-bold leading-none text-dark-charcoal">
              POINTS
            </span>
            <span className="mt-1 text-3xl font-bold leading-none text-skin-fill">
              {auth.user?.points || '--'}
            </span>

            {/** Logout button */}
            <button
              className="mt-10 rounded-full bg-skin-button-accent px-6 pb-3 pt-[0.6rem] font-bold text-white transition-colors hover:bg-skin-button-accent-hover active:translate-y-[0.75px] active:scale-[0.99]"
              onClick={handleLogout}
            >
              log out
            </button>
          </div>
        </div>
      </main>
    </>
  )
}

export default Profile
